import React from "react";
import UserAvatar from "./user-avatar";

const UserAvatarWithDetails = ({
  fullName,
  email,
  workEmail = "",
  style,
  photo = null,
  badge = null,
  //size,
  showAvatar,
}) => {
  let url = photo ? photo : null;
  //let _size = size ? size : "default";
  const _showAvatar = showAvatar !== undefined ? showAvatar : true;

  return (
    <div className="users-details-container" style={style}>
      {_showAvatar && (
        <UserAvatar url={url} email={email} fullName={fullName} />
      )}
      <div className="name-email">
        <div className="name">
          {fullName || "N/A"} {badge}
        </div>
        <div className="email">{email}</div>
        {workEmail && (
          <div className="email">
            <b>Work Email:</b> <br /> {workEmail}
          </div>
        )}
      </div>
      <style>{`
        .users-details-container {
          position: relative;
          display: flex;
          flex-direction: row;
          align-items: center;
        }

        .name-email {
          display: flex;
          flex-direction: column;
          margin-left: 15px;
        }

        p {
          line-height: 1.2em;
          padding: 0;
          margin: 0;
        }

        .name {
          font-size: 1em;
        }

        .email {
          font-weight: normal;
          font-size: 0.85em;
          color: #888;
        }

        .avatar-with-badge {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }
      `}</style>
    </div>
  );
};

export default UserAvatarWithDetails;
